import * as Sentry from '@sentry/react';

import { Crisp } from 'crisp-sdk-web';

let userObj = { displayName: '', uid: '' };

const setUserObj = (_userObj) => {
  try {
    Crisp.setTokenId(_userObj.uid ?? 'Unknown UID');
    Crisp.user.setEmail(_userObj.email ?? 'Unknown Email');
    Crisp.user.setNickname(_userObj.displayName ?? 'Unknown Name');
    Crisp.session.setData({
      uid: _userObj.uid,
      currentScreen: window.location.href,
      platform: 'web',
    });
    Crisp.session.setSegments(['web']);
  } catch (e) {
    console.error('Error setting crisp userObj', e);
  }

  userObj = { ..._userObj };
};

const getLastUpdated = () => {
  console.log('getLastUpdated userObj', userObj);
  return {
    lastUpdated: {
      uid: userObj.uid,
      name: userObj.displayName ?? userObj.email ?? 'Unknown User',
      time: Date.now(),
      platform: 'web',
      deviceId: window.navigator.userAgent,
      deviceName: window.navigator.userAgent,
      release: 'web',
      dist: 'web',
      manufacturer: 'web',
      brand: 'web',
      environment: 'web',
      uniqueId: `web_${Date.now()}`,
      fingerprint: 'web',
      currentInstallTime: 0,
      currentInstallTimeString: 'web',
    },
  };
};

function recordBreadcrumb(message, data) {
  Sentry.addBreadcrumb({
    message,
    level: 'info',
    data,
  });
}

function recordError(err, data) {
  console.error(err, data);
  if (data) {
    recordBreadcrumb(err?.message ?? err, data);
  }
  Sentry.captureException(err);
}

const checkForUndefinedInObject = (obj, objName) => {
  return (
    obj &&
    Object.keys(obj).forEach((key) => {
      if (typeof obj[key] === 'undefined') {
        console.log(
          `Undefined found: ${key} in ${objName} : ${JSON.stringify(
            obj,
            null,
            2,
          )}`,
        );
        recordBreadcrumb(
          `Undefined found: ${key} in ${objName} in obj with keys ${JSON.stringify(
            Object.keys(obj, null, 2),
          )}`,
        );
      } else if (typeof obj[key] === 'object') {
        checkForUndefinedInObject(obj[key], objName);
      }
    })
  );
};

export {
  checkForUndefinedInObject,
  getLastUpdated,
  recordBreadcrumb,
  recordError,
  setUserObj,
};
